import React from 'react';
import ReactDOM from 'react-dom';
import '../node_modules/jquery/dist/jquery.min.js'
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import '../node_modules/font-awesome/css/font-awesome.css';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {initializeFirebase} from "./fcmInicjalize/firebase";
import {initializePush} from "./fcmInicjalize/initialize";
ReactDOM.render(<App />, document.getElementById('root'));
initializeFirebase();
initializePush();
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js